const $ = require('./jquery-core');
require('./jquery-ui');

module.exports = $;
